export class CreateTagDefinitionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowedValues",
            "baseName": "allowedValues",
            "type": "Set<string>",
            "format": ""
        },
        {
            "name": "inheritance",
            "baseName": "inheritance",
            "type": "DataCatalogTagInheritance",
            "format": ""
        },
        {
            "name": "applicableResourceTypes",
            "baseName": "applicableResourceTypes",
            "type": "Array<DataCatalogTagResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateTagDefinitionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
